import {
  ImageEditorComponent,
  OpenEventArgs,
} from "@syncfusion/ej2-react-image-editor";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useEffect, useState } from "react";
import { Container, Row } from "react-grid-system";

interface IAddImageModal {
  open: boolean;
  onAddImage: (folder: string, imageName: string, imageContent: Blob) => void;
  onClose: () => void;
  partProductionOrder: string;
  image?: string;
}

export const AddImageModal: FC<IAddImageModal> = ({
  open,
  onAddImage,
  onClose,
  partProductionOrder,
  image,
}) => {
  const [imageName, setImageName] = useState(image);
  const [imageContent, setImageContent] = useState<Blob>();
  const [errors, setErrors] = useState("");

  const changeHandler = (event: any) => {
    setImageName(event.value);
  };

  let textareaObj: any;

  useEffect(() => {
    validate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageName, imageContent]);

  const buttons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
        disabled: errors && errors.length > 0 ? true : false,
      },
      click: () => {
        if (imageName && imageContent) {
          saveBlob();
          onAddImage(`images${partProductionOrder}`, imageName, imageContent);
        }
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 50 };

  let imgObj: ImageEditorComponent | null;

  let toolbar = ["Finetune", "Filter", "Confirm", "Reset", "Open"];

  //"ZoomIn",
  //"ZoomOut",

  const validate = () => {
    let error = "";
    if (!imageName || image?.length === 0) {
      error = "Please enter image name.";
    }

    if (!imageContent) {
      error = error + " Please select image.";
    }

    setErrors(error);
  };

  function saveBlob(args?: OpenEventArgs): void {
    if (imgObj) {
      let imageData = imgObj.getImageData();
      let canvas = document.createElement("canvas");
      let ctx: any = canvas.getContext("2d");
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      ctx.putImageData(imageData, 0, 0);
      const blob = canvas.toBlob((blob) => {
        if (blob) {
          setImageContent(blob);
          if (args) {
            setImageName(`${args.fileName}.${args.fileType}`);
          }
        }
      });
    }
  }

  return (
    <DialogComponent
      width="600px"
      close={onClose}
      header={`Add Image to ${partProductionOrder} Part Production Order`}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <TextBoxComponent
              ref={(scope : TextBoxComponent) => {
                textareaObj = scope;
              }}
              multiline={false}
              placeholder="Enter image name"
              value={imageName}
              input={changeHandler}
            />
          </Row>
          <Row align="stretch">
            <ImageEditorComponent
              ref={(img : ImageEditorComponent) => {
                imgObj = img;
              }}
              height="300px"
              width="550px"
              toolbar={toolbar}
              fileOpened={saveBlob}
              uploadSettings={{ allowedExtensions: ".jpg,.jpeg,.png,.gif" }}
            ></ImageEditorComponent>
          </Row>

          <Row align="stretch">
            <h6 style={{ color: "red" }}>{errors}</h6>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
